import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP:
//   - RLS predicate + fail-closed posture: supabase/migrations/194_llm_call_costs_rls_policy.sql
//   - 5-layer defense-in-depth + tenant_id-everywhere: docs/content/04-multi-tenant-security.md
//   - access-control fail-closed: src/lib/rag/access-control.ts
//   - field encryption AES-256-GCM: src/lib/security/field-encryption.ts
//   - brute-force lockout (5 attempts / 15 min): src/lib/auth/brute-force-protection.ts
//   - rate limits (chat 60, api 200, auth 15, upload 50 per min): src/lib/rate-limit/index.ts

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 5.4, caption: "In multi-tenant SaaS, one missing WHERE clause leaks another company's data — and the product is dead." },
];

export const PYRAMID: ScriptLine[] = [
  { scene: "pyramid", fromSec: 0.4, holdSec: 6, caption: "Every tenant shares one database, one cache, one set of API routes. I built five layers of defense-in-depth." },
  { scene: "pyramid", fromSec: 7, holdSec: 5.5, caption: "Network. Auth. Authorization. Data protection. Audit. If one layer fails, the ones below still catch it." },
  { scene: "pyramid", fromSec: 13, holdSec: 4.5, caption: "But one layer is load-bearing — and it lives inside Postgres itself." },
];

export const RLS: ScriptLine[] = [
  { scene: "rls", fromSec: 0.4, holdSec: 6, caption: "Layer 3, authorization. The big one is Row-Level Security — enforced by the database, not my code." },
  { scene: "rls", fromSec: 7, holdSec: 6, caption: "Every table carries a tenant_id. Every table has an RLS policy reading it from the signed JWT." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6.5, caption: "This is the real policy. The predicate compares the row's tenant_id to the tenant_id claim in the JWT." },
  { scene: "code", fromSec: 7.5, holdSec: 7, caption: "USING gates reads. WITH CHECK gates writes. You cannot insert a row for someone else's tenant either." },
  { scene: "code", fromSec: 15, holdSec: 8, caption: "It's idempotent — DROP POLICY IF EXISTS, then CREATE. Real SQL, applied as migration 194." },
];

export const FAILCLOSED: ScriptLine[] = [
  { scene: "failclosed", fromSec: 0.4, holdSec: 6, caption: "And it fails closed. Enable Row-Level Security with no policy yet, and Postgres denies everyone by default." },
  { scene: "failclosed", fromSec: 7, holdSec: 6, caption: "No JWT, no tenant claim, no match — zero rows. The safe state is the default state." },
];

export const EVERYWHERE: ScriptLine[] = [
  { scene: "everywhere", fromSec: 0.4, holdSec: 6, caption: "The trap is thinking RLS is enough. tenant_id has to be in everything." },
  { scene: "everywhere", fromSec: 7, holdSec: 6.5, caption: "Cache keys, MCP API keys, audit logs, rate limits, the knowledge graph — every one is tenant-scoped." },
  { scene: "everywhere", fromSec: 13.5, holdSec: 4, caption: "Miss one — a single cache key — and you have a leak waiting to happen." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 6, caption: "So even if I write SELECT star with no WHERE clause, the engine still only returns my tenant's rows." },
  { scene: "payoff", fromSec: 7, holdSec: 6.5, caption: "The isolation isn't a filter in my JavaScript someone could bypass. It's a constraint inside Postgres." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "Enterprise-grade isolation, solo: put the guarantee where the data lives — at the database row." },
  { scene: "outro", fromSec: 6.2, holdSec: 4.5, caption: "Next: making this knowledge base queryable from any AI IDE over MCP." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
